import { Divider, Button } from "antd";
import React, { useState } from "react";
import ModalWrapper from "../Modal";

const Contribution = ({ onClose }) => {
  const [add, setAdd] = useState(false);
  const items = [
    {
      name: "EOBI",
      amount: "RS 0",
    },
    {
      name: "provident fund",
      amount: "RS 0",
    },
  ];
  return (
    <>
      <ModalWrapper
        open={add}
        onRequestClose={() => setAdd(false)}
        title="Contribution"
      >
        <div className="w-md grid grid-cols-12 space-x-4 space-y-4">
          <div className="col-span-12 ">
            <label htmlFor="salaryType" className="text-md">
              Name in Payslip
              <span className="text-red-500 relative -top-0.5 ml-0.5">*</span>
            </label>
            <input
              type="text"
              placeholder="Name"
              className="border px-2 py-1 rounded-md border-secondary text-md outline-none bg-white w-full"
              //   onChange={handleChange}
              name="weekday_hourly_salary"
              //   value={form.weekday_hourly_salary}
            />
          </div>

          <div className="col-span-12 flex flex-col gap-1 ">
            <label htmlFor="salaryType" className="text-md">
              Calculate Amount
            </label>
            <select className="border px-2 py-1.5 rounded-md border-secondary text-md outline-none capitalize">
              <option value="">Select an option</option>
              <option value="fixed">fixed</option>
              <option value="salary">salary</option>
            </select>
          </div>

          <div className="col-span-12 flex flex-col gap-1">
            <div className="flex items-center">
              <span className="border px-2 py-1 rounded-l-md border-secondary text-md bg-primary text-white">
                RS
              </span>
              <input
                type="text"
                className="border px-2 py-1 rounded-r-md border-secondary text-md outline-none w-full bg-white"
              />
            </div>
          </div>
          <Divider className="col-span-12 !p-0 !m-0" />
          <div className="col-span-12 flex items-center justify-end gap-3 my-3">
            <Button onClick={() => setAdd(false)} >Cancel</Button>
            <Button onClick={() => setAdd(false)} >OK</Button>
          </div>
        </div>
      </ModalWrapper>
      <div className={`flex flex-col w-md ${add && "hidden"}`}>
        <div className="flex justify-end">
          <span
            className="text-[8px] px-2 py-0.5 bg-primary rounded-sm text-white font-semibold cursor-pointer hover:bg-active-color hover:text-white"
            onClick={() => setAdd(true)}
          >
            Add
          </span>
        </div>
        <div className="grid grid-cols-12  border-b-2 border-gray-400">
          <h4 className="col-span-6">Name</h4>
          <h4 className="col-span-6">Amount</h4>
        </div>
        <div className="h-auto max-h-96 overflow-auto">
          {items.map((item) => (
            <div
              className="flex flex-col items-start w-full border-b border-gray-400 capitalize text-md"
              key={item.name}
            >
              <div className="grid grid-cols-12   w-full py-2">
                <h4 className="col-span-6 ">{item.name}</h4>
                <h4 className="col-span-6">{item.amount}</h4>
              </div>
            </div>
          ))}
        </div>

        <Divider className="col-span-12 !p-0 !m-0" />
        <div className="col-span-12 flex items-center justify-end gap-3 my-3">
          <Button onClick={onClose} >Cancel</Button>
          <Button onClick={onClose} >OK</Button>
        </div>
      </div>
    </>
  );
};

export default Contribution;
